import React from 'react';
import { memoizeFunction, mergeStyles } from '@fluentui/react';
import { IAppTheme, useAppTheme } from 'common/theme/AppTheme';
import { getAssetPath } from 'common/utilities/AssetsPath';
import { getQRImageLink } from 'features/device/DeviceHelpers';
import { useLocalizedStrings } from 'i18n';

const getQRClassName = memoizeFunction(({ palette }: IAppTheme) =>
  mergeStyles({ borderColor: palette.white, borderRadius: 8, borderStyle: 'solid', borderWidth: 16, width: 110 })
);

export const ScanQRComponent = () => {
  const { t } = useLocalizedStrings('devices');
  const theme = useAppTheme();
  const className = getQRClassName(theme);
  const qrImageLink = getQRImageLink();

  const qrLinkUrl = getAssetPath(qrImageLink!);

  // i18next-extract-mark-ns-start devices
  return <img src={qrLinkUrl} alt={t('AddDevice.Dialog.Share.QR')} className={className} />;
  // i18next-extract-mark-ns-stop devices
};
